import api from '@/utils/api';

/**
 * Create contact person
 * @param {object} contactPersonData - The user data
 * @returns {Promise}
 */
const createContactPersonApi = (contactPersonData) =>
  api.post('/customer/contact-person', contactPersonData);

export default createContactPersonApi;
